var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNwoLogo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.73 229.61",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "NWO_logo_svg__a",
    x1: 3.44,
    x2: 138.29,
    y1: 231.59,
    y2: -1.99,
    "data-name": "Naamloos verloop 6",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e657d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#28869c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3b9fb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42a8bb"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M.25 0h141.48v229.61H.25z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.97V0h38.13c-1.17.55-2.33 1.13-3.48 1.74C19.06 10.01 7.01 23.05 0 38.97Zm129.2 190.64h12.53v-12.36c-2.21 5.67-6.67 10.18-12.53 12.36Zm4.76-20.5v-.12c0-7.29-5.41-12.97-12.8-12.97s-12.51 5.56-12.51 12.85v.12c0 7.29 5.24 13.14 12.63 13.14s12.68-5.73 12.68-13.02ZM6.06 54.02C.81 71.14 2.53 89.28 10.93 105.1c8.39 15.82 22.44 27.43 39.56 32.68s35.26 3.52 51.08-4.87 27.43-22.44 32.68-39.56a67.39 67.39 0 0 0 2.98-19.75c0-8.79-1.75-17.51-5.2-25.75 1.6 8.25 1.17 16.81-1.36 25.07-4.07 13.26-13.06 24.14-25.31 30.63-7.6 4.03-15.9 6.08-24.27 6.08-5.12 0-10.27-.77-15.3-2.31-13.26-4.07-24.14-13.06-30.64-25.3-13.41-25.29-3.75-56.77 21.54-70.19 4.73-2.51 9.72-4.24 14.84-5.19-11.3-.25-22.53 2.37-32.79 7.81-15.82 8.4-27.43 22.45-32.68 39.57Zm68.38 1.55c-3.49 0-6.71-1.1-9.36-2.97 3.34 5.84 8.68 10.12 15.14 12.1 6.73 2.06 13.86 1.38 20.07-1.91 6.22-3.3 10.78-8.82 12.84-15.55 2.07-6.73 1.39-13.86-1.91-20.08-6.81-12.84-22.79-17.74-35.62-10.93a26.149 26.149 0 0 0-9.99 9.33c2.55-1.65 5.58-2.62 8.84-2.62 9.01 0 16.31 7.3 16.31 16.31s-7.3 16.31-16.31 16.31ZM39.57 73.33c5.42 10.21 14.49 17.7 25.54 21.1 11.05 3.39 22.76 2.28 32.98-3.14 10.21-5.42 17.7-14.49 21.1-25.54 3.07-10.01 2.43-20.57-1.74-30.06.95 5.12.67 10.43-.9 15.55-2.56 8.36-8.23 15.22-15.95 19.31-4.79 2.54-10.02 3.83-15.29 3.83-3.23 0-6.47-.48-9.64-1.46-8.36-2.57-15.22-8.23-19.31-15.95C47.91 41.03 54 21.18 69.94 12.73c2.54-1.35 5.18-2.32 7.86-2.95-6.85 0-13.79 1.6-20.25 5.03-21.08 11.18-29.14 37.43-17.96 58.52Zm67.97 65.86c-37.88 20.1-85.05 5.62-105.15-32.28-.86-1.63-1.65-3.29-2.39-4.96V229.6h10.98v-41.09h7.3L35.9 212.3v-23.79h8.92v41.09h12.62l-10.27-41.09h10.15l5.47 24.08 7.41-24.2h7.53l7.41 24.43 5.53-24.31h10L90.4 229.6h22.74c-8.41-3.14-13.83-11.13-13.83-20.49v-.12c0-12.09 9.13-21.94 22-21.94 9.75 0 17.34 5.59 20.45 13.55v-97.58c-7.08 15.44-18.93 28.08-34.19 36.17ZM104.07 0c15.25 7.1 27.73 18.89 35.74 34.01.68 1.29 1.32 2.59 1.92 3.9V0h-37.67ZM65.88 229.61h15.98l-8.03-24.21-7.95 24.21Zm-45.92 0h17.9l-17.9-24.23v24.23Z",
    style: {
      fill: "url(#NWO_logo_svg__a)"
    }
  }));
};
export { SvgNwoLogo as ReactComponent };
export default __webpack_public_path__ + "static/media/NWO_logo.e55a3eb95319f03bec64.svg";